import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from 'components/Button';
import moment from 'moment-timezone';
import FormHelperText from '@mui/material/FormHelperText';
import Form from 'components/form';
import { useForm } from './Form';
const { FormItem } = Form;

const getTimeSlot = (choice, type, tz) => {
  if (type === 'recurring') {
    const date = moment
      .utc()
      .startOf('day')
      .day(choice.dow)
      .minute(choice.time);
    const now = moment().tz(tz);
    if (now.isAfter(date)) {
      date.add(1, 'week');
    }
    return date;
  } else {
    return moment(choice.date);
  }
};

const ButtonForm = React.forwardRef(
  ({ options, type, onChange, value, helpText, hasError, tz }, ref) => {
    const choices = useMemo(() => {
      if (!options) return [];
      return options.map((choice) => {
        return {
          ...choice,
          datetime: getTimeSlot(choice, type, tz).format('MMMM Do, h:mm a'),
        };
      });
    }, []);

    return (
      <Box mt={1.5} ref={ref}>
        <Grid container spacing={1} justifyContent="center">
          {choices.map((choice) => (
            <Grid item xs={12} key={choice.id}>
              <Button
                fullWidth
                variant={choice.id === value?.id ? 'contained' : 'outlined'}
                onClick={() => onChange(choice)}
              >
                {choice.datetime}
              </Button>
            </Grid>
          ))}
        </Grid>
        {hasError && (
          <FormHelperText error sx={{ m: 0, mt: 1 }}>
            {helpText}
          </FormHelperText>
        )}
      </Box>
    );
  },
);

const Scheduler = ({ id, required, settings, options, account }) => {
  const { type } = settings;
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [{ required, message: 'Please select a time' }],
      })(
        <ButtonForm
          options={options}
          type={type}
          tz={account.account_timezone}
        />,
      )}
    </FormItem>
  );
};

export default Scheduler;
